import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import { iteratePromisesInChunks } from '../../shared/libraries/utils/array'

const fetchCityPlanMissionFormChunks = async ({
  cityPlanId,
  chunkSize = 200,
  skip = 0,
}) => {
  const gql = `
      query ($cityPlanId:ID!, $missionStatuses: [MissionStatusEnum], $first: Int, $skip: Int) {
    cityPlans(cityPlanId: $cityPlanId) {
      edges {
        node {
           id
          missions(statuses: $missionStatuses, first: $first, skip: $skip) {
            pageInfo {
              hasNextPage
            }
            edges {
              node {
                id
                flyerCode
                flyerCodeV2 {
                  id
                  code
                  tag
                }
                status
                totalFlyersDistributed
                dateTime
                distributionCost: distributionCostV2
                draftPayAdjustment
                printingCostPerFlyer: printingCostPerFlyerV2
                packSize
                bonusPerConversion
                bonusRedemptionPeriod
                cancelled
                automatic
                type
                user {
                  id
                  firstName
                  lastName
                }
                location {
                  id
                  name
                  hasPermit
                  rank
                  detailedRank
                  type {
                    name
                  }
                }
                metricResults {
                  nodes {
                    id
                    value
                    metric {
                      id
                      name
                    }
                  }
                }
                conversions {
                  nodes {
                    id
                    timestamp
                    metric {
                      id
                      isPrimary
                    }
                  }
                }
                boundary {
                  latitude
                  longitude
                }
                boundaryColour
                costPerFlyer
                amountScans
              }
            }
          }
        }
      }
    }
  }
  `
  const res = await callAuthorizedGraphQLEndpoint(gql, {
    cityPlanId,
    first: chunkSize,
    skip,
    missionStatuses: ['UNDER_REVIEW', 'COMPLETED', 'PAID'],
  })

  const { data } = await res.json()
  let missionsResult = data.cityPlans.edges[0].node.missions.edges

  if (data.cityPlans.edges[0].node.missions.pageInfo.hasNextPage) {
    const { missions } = await fetchCityPlanMissionFormChunks({
      cityPlanId,
      chunkSize,
      skip: chunkSize + skip,
    })

    missionsResult = [...missionsResult, ...missions]
  }
  return {
    missions: missionsResult,
  }
}

const getStatsCampaign = async ({
  campaignId,
  cityPlanChunk,
  missionChunk,
}) => {
  const gqlCampaign = `query ($campaignId:ID!) {
    campaign(id:$campaignId){
      id
      name
      pitchUrl
      type
      bonusLimit
      country{
        currencySign
        code
      }
      metrics {
        nodes {
          id
          name
          targetConversionRate
          targetCostPerMetric
          isPrimary
        }
      }
      client {
        id
        logo
      }
      clientReferralProgram{
       npsEmailDate
       referralEmailDate
       score
      }
      status
      deliverabilityReport{
       id
      }
      cityPlans{
        nodes {
           id
        }
      }
    }
  }`

  const gqlCityPlans = `
  query ($cityPlanId:ID!) {
    cityPlans(cityPlanId: $cityPlanId) {
      edges {
        node {
          id
          payout
          distributionCost: distributionCostV2
          teamLeaderPayAdjustment
          city {
            id
            name
            lunchCheckInTime
            afternoonCheckInTime
            teamLeaderEnabled
            latitude
            longitude
            country {
              id
              name
              code
            }
            locations{
              edges {
                node {
                  id
                  name
                  hasPermit
                  rank
                  detailedRank
                  type {
                    name
                  }
                }
              }
            }
          }
          permitCosts {
            nodes {
              id
              cost
              startDate
            }
          }
        }
      }
    }
  }
  `

  const campaignResponse = await callAuthorizedGraphQLEndpoint(gqlCampaign, {
    campaignId,
  })

  const campaign = await campaignResponse.json()

  const campaignResult = campaign.data.campaign
  const cityPlansIds = campaign.data.campaign.cityPlans.nodes
    ? campaign.data.campaign.cityPlans.nodes.map(({ id }) => id)
    : []

  const cityPlans = await iteratePromisesInChunks(
    cityPlansIds,
    cityPlanChunk,
    async cityPlanId => {
      const cityPlanResponse = await callAuthorizedGraphQLEndpoint(
        gqlCityPlans,
        {
          cityPlanId,
        },
      )

      const { missions } = await fetchCityPlanMissionFormChunks({
        cityPlanId,
        chunkSize: missionChunk,
        skip: 0,
      })

      const resCityPlanResponse = await cityPlanResponse.json()

      const cityPlan = resCityPlanResponse.data.cityPlans.edges[0].node

      return {
        ...cityPlan,
        missions: {
          edges: missions,
        },
      }
    },
  )

  return { ...campaignResult, cityPlans: { nodes: cityPlans } }
}

export { getStatsCampaign }



// WEBPACK FOOTER //
// ./src/Containers/StatsDashboard/gql.js